import React from 'react';
import Icon from '@mdi/react';
import { mdiApple } from '@mdi/js';
import { useFadeUp } from '../../shared/useFadeUp';
import {
  APP_STORE_URL_BADGE,
  GOOGLE_PLAY_URL_BADGE,
} from '../../../constants/storeLinks';
import {
  mobileObservationOffline,
  mobileCalendar,
  appDownloadQr,
} from '../../../assets/v2';
import './download.css';

const GooglePlayIcon: React.FC = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 512 512"
    aria-hidden="true"
    className="v2-download__google-icon"
  >
    <path
      fill="#00d4ff"
      d="M60 24c-5 3-8 9-8 17v430c0 8 3 14 8 17l230-232L60 24z"
    />
    <path
      fill="#ffce00"
      d="M384 180l-60-35-55 56 55 56 60-35c18-11 18-31 0-42z"
    />
    <path
      fill="#ff3b4e"
      d="M269 201L63 488c5 3 11 2 18-2l243-141-55-57-0-1 0 0z"
    />
    <path fill="#00e676" d="M269 199l55-57L81 26c-7-4-13-5-18-2l206 175z" />
  </svg>
);

const Download: React.FC = () => {
  const phones = useFadeUp<HTMLDivElement>();
  const content = useFadeUp<HTMLDivElement>();

  return (
    <section className="v2-download" id="download">
      <div className="v2-download__container">
        <div
          ref={phones.ref}
          className={`v2-download__phones fade-up ${phones.isVisible ? 'is-visible' : ''}`}
        >
          <img
            className="v2-download__phone v2-download__phone--back"
            src={mobileObservationOffline}
            alt="Morph app — observation screen"
            loading="lazy"
          />
          <img
            className="v2-download__phone v2-download__phone--front"
            src={mobileCalendar}
            alt="Morph app — calendar screen"
            loading="lazy"
          />
        </div>
        <div
          ref={content.ref}
          className={`v2-download__content fade-up ${content.isVisible ? 'is-visible' : ''}`}
        >
          <div className="v2-download__info">
            <h2 className="ui-h2">Get Morph on your phone.</h2>
            <p className="ui-body">Accelerate your inspection work.</p>
          </div>
          <div className="v2-download__qr-block">
            <img
              className="v2-download__qr"
              src={appDownloadQr}
              alt="QR code — scan to download Morph"
            />
            <p className="v2-download__qr-hint">
              Scan to download, or get it from:
            </p>
          </div>
          <div className="v2-download__badges">
            <a
              href={APP_STORE_URL_BADGE}
              target="_blank"
              rel="noopener noreferrer"
              className="v2-download__badge"
              aria-label="Download on the App Store"
            >
              <Icon path={mdiApple} size={1.1} />
              <span className="v2-download__badge-text">
                <span className="v2-download__badge-sub">Download on the</span>
                <span className="v2-download__badge-name">App Store</span>
              </span>
            </a>
            <a
              href={GOOGLE_PLAY_URL_BADGE}
              target="_blank"
              rel="noopener noreferrer"
              className="v2-download__badge"
              aria-label="Get it on Google Play"
            >
              <GooglePlayIcon />
              <span className="v2-download__badge-text">
                <span className="v2-download__badge-sub">GET IT ON</span>
                <span className="v2-download__badge-name">Google Play</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
